<div class="container m-b-20" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px">
  <div #createDatatableRef class="in-block">
    <button mat-raised-button color="primary" [routerLink]="['create']" *mifosxHasPermission="'CREATE_DATATABLE'">
      <fa-icon icon="plus" class="m-r-10"></fa-icon>
      Create Data Table
    </button>
  </div>
</div>

<div class="container">

  <div #filter fxLayout="row" fxLayoutGap="20px">
    <mat-form-field fxFlex>
      <mat-label>{{ 'labels.inputs.Filter' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)">
    </mat-form-field>
  </div>

  <div #datatablesList class="mat-elevation-z8">

    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="registeredTableName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Table Name </th>
        <td mat-cell *matCellDef="let dataTable"> {{ dataTable.registeredTableName }} </td>
      </ng-container>

      <ng-container matColumnDef="applicationTableName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Associated With </th>
        <td mat-cell *matCellDef="let dataTable"> {{ dataTable.applicationTableName }} </td>
      </ng-container>

      <ng-container matColumnDef="entitySubType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sub Type </th>
        <td mat-cell *matCellDef="let dataTable"> {{ dataTable.entitySubType }} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="[row.registeredTableName]" class="select-row"></tr>

    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>

  </div>

</div>

<ng-template #templateCreateDatatableRef let-popover="popover">
  <h2>Create Data Table</h2>
  <p class="mw300">This will launch a page that will allow you to create a new data table.</p>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn" (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary" (click)="popover.close();previousStep();">Back</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover(templateFilter,filter,'bottom', true);">Next</button>
  </div>
</ng-template>

<ng-template #templateFilter let-popover="popover">
  <h4>Search bar to filter datatables.</h4>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn" (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover(templateCreateDatatableRef,createDatatableRef,'bottom', true);">Back</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover(templateDatatablesList,datatablesList,'top', true);">Next</button>
  </div>
</ng-template>

<ng-template #templateDatatablesList let-popover="popover">
  <h4>List of all currently available data tables.</h4>
  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="2%" fxLayout.lt-md="column">
    <button mat-raised-button color="warn" (click)="popover.close();configurationWizardService.closeConfigWizard()">Close</button>
    <button mat-raised-button color="primary" (click)="popover.close();showPopover(templateFilter,filter,'bottom', true);">Back</button>
    <button mat-raised-button color="primary" (click)="popover.close();nextStep();">Next</button>
  </div>
</ng-template>
